import { IconCalendar as TablerIconCalendar } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconCalendar = /*#__PURE__*/ createOutlineIcon(TablerIconCalendar, 'IconCalendar');
